// Doc-Ref: docs/features/collaborations-current.md

const PageHeader = ({ extra }) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 w-full">
      <div className="flex flex-col">
        <h1 className="text-2xl font-semibold text-gray-900 m-0 mb-1 tracking-tight">Collaborations</h1>
        <p className="text-sm text-gray-500 m-0 max-w-3xl leading-relaxed">
          Evaluate the depth of existing research relationships and identify
          high-potential collaboration opportunities across geographies
          and subject areas.
        </p>
      </div>
      {extra && (
        <div className="flex-shrink-0">
          {extra}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
